import { render, staticRenderFns } from "./AddCollection.vue?vue&type=template&id=798a9653&"
import script from "./AddCollection.vue?vue&type=script&lang=js&"
export * from "./AddCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports